/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { logEvent } from '@redux-beacon/amplitude';
import debug from 'debug';

const log = debug('amplitude');

export default {
  'department/fetchAll/fulfilledx': logEvent(() => {
    log('event.type = department.fulfilled');
    return {
      type: 'department.fulfilled'
    };
  })
};
